import Location from "../../hooks/Location";
import { client } from "../../hooks/Client";
import { ActiveMenu } from "../../StateManagment/ActiveMenuItem";
import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { usePageConfig } from "../../hooks/usePageConfig";

const TopBarBreadCrumb = () => {
    const { active, setActive, activeSubItem, setActiveSubItem } = useContext(ActiveMenu);
    const { getBreadcrumbTrail } = usePageConfig();
    
    const locationParts = Location(); // Get URL parts
    const pageName = locationParts[2]; // The specific page name
    const id = locationParts[3]; // Extract ID if available
    const history = useHistory();

    // Generate Breadcrumbs based on page hierarchy
    const generateBreadcrumbs = (breadcrumbs) => (
        <div id="topbar-breadcrumb-links-container">
            <p
                className='topbar-breadcrumb-home'
                onClick={() => history.push(`/${client}/dashboard`)}
            >
                Home
            </p>
            {breadcrumbs.map((breadcrumb, index) => {
                // Ensure the link retains the ID if necessary
                const link = breadcrumb.link + (id ? `/${id}` : "");
                const isLast = index === breadcrumbs.length - 1;

                return (
                    <span key={index} className='topbar-breadcrumb-crumb'>
                        <span className='topbar-breadcrumb-separator'>
                            {index === 0 ? '/' : '›'}
                        </span>
                        <p
                            className={isLast ? 'topbar-breadcrumb-current' : ''}
                            onClick={() => {
                                history.push(`/${client}/${link}`);
                                setActive(breadcrumb.link);
                                setActiveSubItem(breadcrumb.subItem || "");
                            }}
                        >
                            {breadcrumb.name}
                        </p>
                    </span>
                );
            })}
        </div>
    );

    // Retrieve the breadcrumb trail based on the page name. Some pages (the
    // live-report viewer/builder) serve both reports and templates from one
    // URL — ?template=true selects the "-template" config variant, which
    // falls back to the base page when no variant exists.
    const renderBreadCrumb = () => {
        const isTemplate = new URLSearchParams(window.location.search).get('template') === 'true';
        const breadcrumbs = getBreadcrumbTrail(isTemplate ? `${pageName}-template` : pageName);
        return generateBreadcrumbs(breadcrumbs);
    };

    return <div id="topbar-breadcrumb-container">{renderBreadCrumb()}</div>;
};

export default TopBarBreadCrumb;


